import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { DatePicker, Table, Row, Col } from 'antd';
import Loading from '@components/Loading';
import Chart from '@components/charts/Chart';
import { COLORS } from '@components/charts/chart.constant';
import { apiGetConsumptionByBranchByDay } from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import { formatCurrency } from '@utils/utils';
import dayjs from 'dayjs';

const ConsumptionChart = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs().subtract(1, 'day'));

  useImperativeHandle(ref, () => ({
    refetch: () => {
      fetchData(selectedDate);
    }
  }));

  const fetchData = async (date) => {
    setLoading(true);
    try {
      const res = await apiGetConsumptionByBranchByDay({
        date: dayjs(date).format('YYYY-MM-DD')
      });

      if (res.data?.data?.branches) {
        // Ensure data is an array - branches is inside data object
        const responseData = Array.isArray(res.data.data.branches) ? res.data.data.branches : [];
        console.log('data: tieyu ngay:::', responseData);

        setData(responseData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching consumption data:', error);
      showError('Không thể tải dữ liệu tiêu thụ');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(selectedDate);
  }, [selectedDate]);

  // Convert branch name to abbreviated form
  const convertToAbbreviation = (branchName) => {
    if (!branchName) return '';
    // Remove "Nhà máy" and get remaining text
    const cleanName = branchName.replace(/Nhà máy\s*/gi, '').trim();
    // Get first letter of each word (including "cấp nước")
    // return cleanName
    //   .split(' ')
    //   .map((word) => word.charAt(0).toUpperCase())
    //   .join('');
    return branchName;
  };

  const categories = Array.isArray(data)
    ? data.map((item) => convertToAbbreviation(item.branch_name) || item.branch_code)
    : [];
  const seriesData = Array.isArray(data)
    ? data.map((item) => parseFloat(item.consumption || 0) / 1000)
    : [];

  const series = [
    {
      name: 'Tiêu thụ (m³)',
      data: seriesData,
      type: 'bar'
    }
  ];

  console.log('seriesData:::', seriesData);

  // Calculate total consumption
  const totalConsumption = Array.isArray(data)
    ? data.reduce((sum, item) => sum + parseFloat(item.consumption || 0), 0) / 1000
    : 0;

  // Prepare table data
  // const tableData = Array.isArray(data)
  //   ? data.map((item, index) => ({
  //       key: index,
  //       branch_name: convertToAbbreviation(item.branch_name) || item.branch_code,
  //       consumption: parseFloat(item.consumption || 0) / 1000
  //     }))
  //   : [];

  // // Add total row
  // const dataWithTotal = [
  //   ...tableData,
  //   {
  //     key: 'total',
  //     branch_name: 'Tổng',
  //     consumption: totalConsumption,
  //     isTotal: true
  //   }
  // ];

  // const columns = [
  //   {
  //     title: 'Nhà máy',
  //     dataIndex: 'branch_name',
  //     key: 'branch_name',
  //     render: (text, record) => (record.isTotal ? <strong>{text}</strong> : text)
  //   },
  //   {
  //     title: 'Tiêu thụ ngày (m³)',
  //     dataIndex: 'consumption',
  //     key: 'consumption',
  //     align: 'right',
  //     render: (value, record) => {
  //       const formatted = formatCurrency(value, 2);
  //       return record.isTotal ? <strong>{formatted}</strong> : formatted;
  //     }
  //   }
  // ];

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <DatePicker
          value={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          format="DD/MM/YYYY"
          placeholder="Chọn ngày"
        />
        <div style={{ fontSize: '18px', color: '#0051A9', fontWeight: '600' }}>
          Tổng tiêu thụ: {formatCurrency(totalConsumption)} m³
        </div>
      </div>
      {loading ? (
        <div className="loading-container">
          <Loading />
        </div>
      ) : (
        <div className="chart-container">
          <Chart
            options={{
              colors: COLORS,
              chart: {
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: true
                }
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '50%',
                  borderRadius: 0,
                  dataLabels: {
                    position: 'top'
                  }
                }
              },
              dataLabels: {
                enabled: true,
                offsetY: -16,
                style: {
                  fontSize: '12px',
                  fontWeight: 'bold',
                  colors: ['#595959']
                },
                formatter: (val) => formatCurrency(val)
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },
              xaxis: {
                categories: categories
              },
              yaxis: {
                title: {
                  text: 'Tiêu thụ (m³)'
                },
                labels: {
                  formatter: (val) => Math.round(val).toString()
                }
              },
              grid: {
                show: true
              },
              tooltip: {
                y: {
                  formatter: (val) => `${formatCurrency(val)} m³`
                }
              },
              legend: {
                horizontalAlign: 'left'
              }
            }}
            type="bar"
            series={series}
            height={350}
          />
        </div>
      )}
      {/* <Table
        columns={columns}
        dataSource={dataWithTotal}
        pagination={false}
        size="small"
        bordered
      /> */}
    </div>
  );
});

export default ConsumptionChart;
